<template>
    <div class="search-container">
        <head-search :fixed="true" @search="resetSearch"></head-search>
        <div class="search-filter-box">
            <div
                class="filter-select-item"
                @click="sortChange('normal')"
                :class="normalSortyClass"
            >
                <span>综合</span>
            </div>
            <div
                class="filter-select-item sort-item"
                @click="sortChange('price')"
                :class="priceSortClass"
            >
                <span>价格</span>
            </div>
            <div
                class="filter-select-item sort-item"
                @click="sortChange('stock')"
                :class="stockSortClass"
            >
                <span>库存</span>
            </div>
            <div
                class="filter-select-item filter-icon"
                @click="selectVerlayVisible = true"
            >
                <span>筛选</span>
            </div>
        </div>
        <!-- 商品列表 -->
        <div class="product-fixed-box">
            <scroll
                :data-list="productList"
                @load="onLoad"
                :finished="finished"
            >
                <div class="product-box">
                    <ul
                        class="product-list"
                        v-show="productList.length != 0"
                        v-if="isLoadedList"
                    >
                        <product-item
                            v-for="(item, index) in productList"
                            @buy="openBuyWindow"
                            @relation="openRelationWindow"
                            @relationDelete="deleteRelation"
                            :key="index"
                            :product-info="item"
                        ></product-item>
                    </ul>
                    <div slot="icon">
                        <empty-data
                            v-show="productList.length == 0"
                            iconText="抱歉,没有找到相匹配的商品"
                            :iconSrc="emptyIcon"
                            :paddingTop="6"
                        ></empty-data>
                    </div>
                </div>
            </scroll>
        </div>
        <!-- 商品列表 -->
        <!-- 品类条件筛选 -->
        <div
            class="search-condition-window"
            @click="selectVerlayVisible = false"
            v-show="selectVerlayVisible"
        >
            <div class="search-condition-box" @click.stop>
                <div class="select-wrap">
                    <div class="search-select-box">
                        <div class="select-item-box">
                            <div class="select-item-head">
                                <div class="head-left">
                                    <span>类别</span>
                                </div>
                                <div
                                    class="head-right"
                                    v-show="categoryList.length > 15"
                                >
                                    <!-- <span>全部</span> -->
                                </div>
                            </div>
                            <div class="search-item-main">
                                <span
                                    class="select-text-item"
                                    v-for="(item, index) in categoryList"
                                    :key="index"
                                    :class="{ active: item.selectStatus }"
                                    @click="
                                        changeSelectStatus(
                                            item,
                                            'queryCategoryCache'
                                        )
                                    "
                                    >{{ item.name }}</span
                                >
                            </div>
                        </div>
                        <div class="select-item-box">
                            <div class="select-item-head">
                                <div class="head-left">
                                    <span>品牌</span>
                                </div>
                                <div
                                    class="head-right"
                                    v-show="brandList.length > 15"
                                >
                                    <!-- <span>全部</span> -->
                                </div>
                            </div>
                            <div class="search-item-main">
                                <span
                                    class="select-text-item"
                                    v-for="(item, index) in brandList"
                                    :key="index"
                                    :class="{ active: item.selectStatus }"
                                    @click="
                                        changeSelectStatus(
                                            item,
                                            'queryBrandCache'
                                        )
                                    "
                                    >{{ item.name }}</span
                                >
                            </div>
                        </div>
                        <div class="select-item-box">
                            <div class="select-item-head">
                                <div class="head-left">
                                    <span>封装规格</span>
                                </div>
                                <div
                                    class="head-right"
                                    v-show="specList.length > 15"
                                >
                                    <!-- <span>全部</span> -->
                                </div>
                            </div>
                            <div class="search-item-main">
                                <span
                                    class="select-text-item"
                                    v-for="(item, index) in specList"
                                    :key="index"
                                    :class="{ active: item.selectStatus }"
                                    @click="
                                        changeSelectStatus(
                                            item,
                                            'querySpecCache'
                                        )
                                    "
                                    >{{ item.name }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-sumbit-bar">
                    <div
                        class="search-reset-btn"
                        @click="resetParamsSelectStatus"
                    >
                        <span>重置</span>
                    </div>
                    <div class="search-sumbit-btn" @click="confirmFilter">
                        <span>确定</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 品类条件筛选 -->
        <!-- 购买窗口 -->
        <buy-window @buy="confirmPurchase"></buy-window>
        <!-- 购买窗口 -->
        <!-- 自定义物料窗口 -->
        <BackFill @confirm="confrimRelation"></BackFill>
        <!-- 自定义物料窗口 -->
    </div>
</template>
<script>
const default_count = 0;
import {
    cart_join,
    cart_buy,
    cart_create,
    cart_update,
} from "@/helper/types/cart";
import EmptyData from "@/components/EmptyData";
import { isLogin, getBasket } from "@/utils/auth";
import { isEmpty } from "@/utils/validation";
import { findComponentDownward } from "@/utils/findComponents";
import Scroll from "@/components/Scroll";
import ProductItem from "./children/search/ProductItem";
import utils from "@/utils/utils";
import { addProductRelation, deleteProductRelation } from "@/utils/product";
import HeadSearch from "@/components/HeadSearch";
import BuyWindow from "./children/BuyWindow";
import BackFill from "./children/encode/Backfill";
import Vue from "vue";
import { Overlay, Dialog, Notify, Toast } from "vant";
Vue.use(Overlay)
    .use(Notify)
    .use(Toast);
export default {
    name: "SearchResult",
    components: {
        HeadSearch,
        ProductItem,
        Scroll,
        BuyWindow,
        EmptyData,
        BackFill,
    },
    data() {
        return {
            //空数据icon
            emptyIcon: require("@/public/images/product/product-empty-icon.png"),
            finished: false, //是否加载完毕数据
            selectVerlayVisible: false, //条件筛选过滤层
            isLoadedList: true, //更新商品
            page: 1,
            searchInfo: {
                //搜索信息
                searchWord: "",
                //搜索类别
                categorySecondId: "",
                //品牌id
                brandId: "",
                //封装
                capsulationId: "",
                //排序
                sortRuleType: 0,
                //是否有库存
                stockHave: true,
            },
            isInitSelectParams: false, //是否初始化完毕搜索参数
            productList: [], //商品集合
            categoryList: [], //类别集合
            brandList: [], //品牌集合
            specList: [], //封装集合,
            queryCategoryCache: [], //当前搜索的类别集合
            queryBrandCache: [], //当前搜索的品牌集合
            querySpecCache: [], //当前搜索封装集合
            //商品总数
            productCount: default_count,
        };
    },
    mounted() {
        let key = window.decodeURI(this.$route.query.key || "");
        let _this = this,
            headComponent;
        if (isEmpty(key)) {
            this.$router.push({
                path: "/",
            });
            return;
        }
        this.searchInfo.searchWord = key;
        headComponent = findComponentDownward(this, "HeadSearch");
        headComponent.setKeyWord(key);
        this.getProductList();
    },
    methods: {
        /**
         * @description 加载数据
         */
        onLoad() {
            this.getProductList();
            if (this.productList.length >= this.productCount) {
                this.finished = true;
            }
        },
        /**
         * @param {function} cb 回调
         * @description 获取商品列表
         */
        getProductList(cb) {
            let dividedSymbols = "-";
            let _this = this;
            let {
                searchWord,
                brandId,
                capsulationId,
                sortRuleType,
                stockHave,
                categorySecondId,
            } = this.searchInfo;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(_this.$api.productApi.productSearch, {
                    currentPage: _this.page || 1, //当前页
                    itemsPerPage: _this.$config.PAGE_ITEMS,
                    anyCondition: {
                        searchWord,
                        categorySecondId:
                            _this.queryCategoryCache.join(dividedSymbols) || "",
                        brandId:
                            _this.queryBrandCache.join(dividedSymbols) || "",
                        capsulationId:
                            _this.querySpecCache.join(dividedSymbols) || "",
                        sortRuleType,
                        stockHave,
                    },
                })
                .then((response) => {
                    let data = response.data || {};
                    let contents = data.pageContext;
                    let paramsList = data.groupList;
                    if (contents) {
                        let productList = contents.content || [];
                        _this.productCount = contents.totalElements || 0;
                        _this.productList = _this.productList.concat(
                            productList
                        );
                        _this.page += 1;
                    }
                    if (paramsList) {
                        _this.categoryList = _this.correlationSearchCondition(
                            paramsList.categoryNameGroup,
                            "queryCategoryCache"
                        );
                        _this.brandList = _this.correlationSearchCondition(
                            paramsList.brandGroupName,
                            "queryBrandCache"
                        );
                        _this.specList = _this.correlationSearchCondition(
                            paramsList.capsulationGroup,
                            "querySpecCache"
                        );
                        _this.$toast.clear();
                    }
                    cb && cb();
                })
                .catch(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 获取缓存数据
         */
        getCacheSelectParams(dataName, cacheName, fieldName) {
            let _this = this;
            let cacheData = _this[`${cacheName}`];
            if (!Array.isArray(_this[`${dataName}`])) return;
            _this[`${dataName}`].forEach((item) => {
                let isSelect = cacheData[`${item[`${fieldName}`]}`];
                if (isSelect) {
                    item.selectStatus = true;
                } else {
                    item.selectStatus = false;
                }
            });
        },
        /**
         * @description 改变选中状态数据
         */
        changeSelectStatus(data, cacheName) {
            let _this = this;
            let selectStatus = data.selectStatus;
            let currentId = data.id;
            let cacheMap = {
                queryCategoryCache: _this.queryCategoryCache,
                queryBrandCache: _this.queryBrandCache,
                querySpecCache: _this.querySpecCache,
            };
            let cacheList = _this[`${cacheName}`] || [];
            if (typeof selectStatus === "undefined" || selectStatus === false) {
                selectStatus = true;
            } else {
                selectStatus = false;
            }
            if (selectStatus && !cacheList.includes(currentId)) {
                cacheList.push(currentId);
            } else {
                cacheList.forEach(function(value, index) {
                    if (value == currentId) {
                        cacheList.splice(index, 1);
                    }
                });
            }
            _this.$set(data, "selectStatus", selectStatus);
        },
        /**
         * @param {array} sourece 对比数据源
         * @param {string} cacheName 数据名
         * @description 对比选中数据
         */
        correlationSearchCondition(source, cacheName) {
            if (Array.isArray(source) && cacheName) {
                let _this = this;
                let temp = [];
                let cacheMap = {
                    queryCategoryCache: _this.queryCategoryCache,
                    queryBrandCache: _this.queryBrandCache,
                    querySpecCache: _this.querySpecCache,
                };
                let cacheList = _this[`${cacheName}`] || [];
                source.forEach(function(dataItem) {
                    let currentId = dataItem.id;
                    dataItem.selectStatus = cacheList.includes(currentId)
                        ? true
                        : false;
                    temp.push(dataItem);
                });
                return temp;
            } else {
                return [];
            }
        },
        /**
         * @description 重置参数选择状态
         */
        resetParamsSelectStatus() {
            this.selectVerlayVisible = false;
            this.finished = false;
            this.productCount = default_count;
            this.searchInfo.sortRuleType = 0;
            this.queryCategoryCache = [];
            this.queryBrandCache = [];
            this.querySpecCache = [];
            this.page = 1;
            this.productList = [];
            this.getProductList();
        },
        /**
         * @description 确认过滤
         */
        confirmFilter() {
            let _this = this;
            let fiterList = [
                ..._this.categoryList,
                ..._this.brandList,
                ..._this.specList,
            ];
            let hasSelectStatus = fiterList.every((item) => {
                return item.selectStatus == false;
            });
            if (!hasSelectStatus) {
                this.productCount = default_count;
                this.page = 1;
                this.productList = [];
                this.selectVerlayVisible = false;
                this.finished = false;
                this.getProductList();
            }
        },
        /**
         * @description 重置搜索
         */
        resetSearch() {
            let _this = this;
            this.$router.push({
                path: "/product/search",
                query: {
                    key: encodeURI(_this.searchInfo.searchWord),
                },
            });
        },
        /**
         * @description 排序更改
         */
        sortChange(type) {
            let currentSort = this.searchInfo.sortRuleType;
            const NORMAl_ORDER = 0;
            const PRICE_ASCENDING_ORDER = 3; //价格升序
            const PRICE_DESCENDING_ORDER = 2; //价格将序
            const STOCK_ASCENDING_ORDER = 1; //库存升序
            const STOCK_DESCENDING_ORDER = 4; //库存降序
            if (!type) return;
            if (type == "price") {
                if (currentSort == PRICE_ASCENDING_ORDER) {
                    this.searchInfo.sortRuleType = PRICE_DESCENDING_ORDER;
                } else if (currentSort == PRICE_DESCENDING_ORDER) {
                    this.searchInfo.sortRuleType = PRICE_ASCENDING_ORDER;
                } else {
                    this.searchInfo.sortRuleType = PRICE_ASCENDING_ORDER;
                }
            } else if (type == "stock") {
                if (currentSort == STOCK_ASCENDING_ORDER) {
                    this.searchInfo.sortRuleType = STOCK_DESCENDING_ORDER;
                } else if (currentSort == STOCK_DESCENDING_ORDER) {
                    this.searchInfo.sortRuleType = STOCK_ASCENDING_ORDER;
                } else {
                    this.searchInfo.sortRuleType = STOCK_ASCENDING_ORDER;
                }
            } else if (type == "normal") {
                this.searchInfo.sortRuleType = NORMAl_ORDER;
            }
            this.page = 1;
            this.productList = [];
            this.getProductList();
        },
        /**
         * @description 打开购买窗口
         */
        openBuyWindow(productInfo) {
            let _this = this;
            let productId = productInfo.productId;
            let buyWindowComponent = findComponentDownward(this, "BuyWindow");
            _this.cartHasProduct({
                productId: productId,
                success: (productInfo) => {
                    Dialog.confirm({
                        title: "购物车提示",
                        message: `您的购物车内已有此商品${productInfo.quantity}pcs,确定要替换掉购物车内数量吗?`,
                        confirmButtonColor: "#4BC227",
                    })
                        .then(() => {
                            _this.getProductInfo(productId, (data) => {
                                buyWindowComponent.open(data, cart_update);
                            });
                        })
                        .catch(() => {
                            // on cancel
                        });
                },
                failed: () => {
                    _this.getProductInfo(productId, (data) => {
                        buyWindowComponent.open(data, cart_create);
                    });
                },
            });
        },
        /**
         * @description 获取商品详情
         */
        getProductInfo(productId, cb) {
            this.$axios
                .post(this.$api.productApi.getProductInfo, {
                    context: {
                        productId,
                    },
                })
                .then((response) => {
                    let productInfo = response.data || {};
                    cb && cb(productInfo);
                });
        },
        /**
         * @description 确认购买
         */
        confirmPurchase(info) {
            let _this = this;
            let { eventType, pcs, productId, cartOperation } = info;
            _this.cartOperation({
                type: cartOperation,
                productId: productId,
                pcs: pcs,
                success: (data) => {
                    let msg =
                        cartOperation == cart_create
                            ? "加入购物车成功"
                            : "购物车数量更新成功";
                    if (eventType == cart_join) {
                        _this.$toast.success({
                            message: msg,
                            duration: 2000,
                        });
                    } else {
                        _this.$router.push("/cart");
                    }
                },
            });
        },
        /**
         * @description 购物车操作
         */
        cartOperation(info) {
            if (!info.type) return;
            let { type, pcs, productId, success } = info;
            this.$axios
                .post(this.$api.cartApi.cart_operationApi, {
                    operation: type,
                    context: {
                        quantity: pcs,
                        productId: info.productId,
                        basketId: isLogin() ? "" : getBasket(),
                    },
                })
                .then((response) => {
                    let data = response.data || {};
                    success && success(data);
                });
        },
        /**
         * @description 检测购物车是否包含此商品
         */
        cartHasProduct(info) {
            if (!info) return;
            let { productId, success, failed } = info;
            this.$axios
                .post(this.$api.cartApi.cart_operationApi, {
                    operation: "retrieve",
                    context: {
                        productId: productId,
                    },
                })
                .then((response) => {
                    let data = response.data || {};
                    success && success(data);
                })
                .catch(() => {
                    failed && failed();
                });
        },
        /**
         *  @description 打开物料窗口
         */
        openRelationWindow(productInfo) {
            if (!isLogin()) {
                this.$router.push({
                    path: "/account/login/password",
                });
                return;
            }
            let backFillWindow = findComponentDownward(this, "BackFill");
            backFillWindow.open(productInfo);
        },
        /**
         *  @description 确认关联
         */
        confrimRelation(encodeInfo) {
            let _this = this;
            let encodeOperationURL = this.$api.userApi.encodeOperation;
            let { goodsCode, productId, customCode } = encodeInfo;
            let request = {
                context: {
                    goodsCode,
                    customCode,
                    productId,
                },
                operation: "create",
            };
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(encodeOperationURL, request)
                .then((response) => {
                    let backFillWindow = findComponentDownward(
                        _this,
                        "BackFill"
                    );
                    backFillWindow.close();
                    _this.isLoadedList = false;
                    _this.$nextTick(() => {
                        let productList = addProductRelation(
                            _this.productList,
                            productId,
                            customCode
                        );

                        _this.productList = [...Array.from(productList)];
                        _this.isLoadedList = true;
                    });
                })
                .catch(() => {})
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 删除自定义编码关联
         */
        deleteRelation(productInfo) {
            let _this = this;
            let encodeOperationURL = this.$api.userApi.encodeOperation;
            Dialog.confirm({
                title: "提示",
                message: `确定删除自定义物料编码吗?`,
                confirmButtonColor: "#4BC227",
            })
                .then(() => {
                    let { goodsCode, productId } = productInfo;
                    let request = {
                        context: {
                            goodsCode,
                        },
                        operation: "delete",
                    };
                    _this.$toast.loading({
                        message: "数据加载中...",
                        duration: 0,
                    });
                    _this.$axios
                        .post(encodeOperationURL, request)
                        .then((response) => {
                            _this.isLoadedList = false;
                            _this.$nextTick(() => {
                                let productList = deleteProductRelation(
                                    _this.productList,
                                    productId
                                );

                                _this.productList = [
                                    ...Array.from(productList),
                                ];
                                _this.isLoadedList = true;
                            });
                        })
                        .catch(() => {})
                        .finally(() => {
                            _this.$toast.clear();
                        });
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
    computed: {
        /**
         * @description 价格排序样式
         */
        priceSortClass() {
            let currentSort = this.searchInfo.sortRuleType || 0;
            const ASCENDING_ORDER = 3; //升序
            const DESCENDING_ORDER = 2; //将序
            return {
                "sort-down": currentSort == DESCENDING_ORDER,
                "sort-top": currentSort == ASCENDING_ORDER,
            };
        },
        stockSortClass() {
            let currentSort = this.searchInfo.sortRuleType || 0;
            const ASCENDING_ORDER = 1; //升序
            const DESCENDING_ORDER = 4; //将序
            return {
                "sort-down": currentSort == DESCENDING_ORDER,
                "sort-top": currentSort == ASCENDING_ORDER,
            };
        },
        normalSortyClass() {
            let currentSort = this.searchInfo.sortRuleType || 0;
            const NORAML_ORDER = 0; //正常排序
            return {
                active: currentSort == NORAML_ORDER,
            };
        },
    },
};
</script>
<style lang="less" scoped>
.search-filter-box {
    position: fixed;
    top: 90px;
    z-index: 1;
    width: 750px;
    height: 80px;
    background-color: #fff;
    .filter-select-item {
        float: left;
        width: 25%;
        height: 80px;
        font-size: 28px;
        line-height: 80px;
        text-align: center;
        color: #333;
        &.active {
            color: @theme-color;
        }
    }
    .filter-icon {
        background-image: url("../../public/images/product/fiter-bar-icon.png");
        background-repeat: no-repeat;
        background-size: 26px;
        background-position: 35px center;
    }
    .sort-item {
        background-image: url("../../public/images/product/sort-default-icon.png");
        background-repeat: no-repeat;
        background-size: 20px;
        background-position: 80% center;
        &.sort-top {
            background-image: url("../../public/images/product/sort-top-icon.png");
        }
        &.sort-down {
            background-image: url("../../public/images/product/sort-down-icon.png");
        }
    }
}
.search-condition-box {
    float: right;
    position: relative;
    z-index: 2000;
    width: 640px;
    height: 100%;
    background-color: #fff;
    > .select-wrap {
        position: absolute;
        z-index: 12;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 100px;
        > .search-select-box {
            overflow-y: auto;
            width: 100%;
            height: 100%;
            .select-item-box {
                margin: 0 auto;
                width: 580px;
                border-bottom: 1px solid #f2f2f2;
                &:last-child {
                    border: none;
                }
                .select-item-head {
                    height: 100px;
                    > .head-left {
                        float: left;
                        width: 290px;
                        height: 100px;
                        font-size: 32px;
                        line-height: 100px;
                        color: #333;
                    }
                    > .head-right {
                        float: right;
                        padding-right: 50px;
                        width: 240px;
                        height: 100px;
                        background-image: url("../../public/images/product/select-down-icon.png");
                        background-size: 40px;
                        background-repeat: no-repeat;
                        background-position: right center;
                        font-size: 24px;
                        line-height: 100px;
                        text-align: right;
                        color: #333;
                        &.more-status {
                            background-image: url("../../public/images/product/select-top-icon.png");
                        }
                    }
                }
                .search-item-main {
                    font-size: 0px;
                    .select-text-item {
                        margin: 0 20px 30px 0px;
                        *display: inline;
                        display: inline-block;
                        zoom: 1;
                        padding: 13px 12px;
                        border-radius: 5px;
                        background-color: #f6f6f6;
                        font-size: 24px;
                        color: #333;
                        &.active {
                            background-color: #e0fed7;
                            color: #4bc227;
                        }
                    }
                }
            }
        }
    }
    > .search-sumbit-bar {
        position: absolute;
        z-index: 20;
        width: 640px;
        height: 100px;
        left: 0;
        bottom: 0;
        .search-reset-btn {
            float: left;
            width: 50%;
            height: 100px;
            font-size: 32px;
            line-height: 100px;
            text-align: center;
            color: @theme-color;
            background-color: #e0fed7;
        }
        > .search-sumbit-btn {
            float: left;
            width: 50%;
            height: 100px;
            font-size: 32px;
            line-height: 100px;
            text-align: center;
            color: #fff;
            background-color: @theme-color;
        }
    }
}
.search-condition-window {
    position: fixed;
    z-index: 2000;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
.product-fixed-box {
    position: fixed;
    z-index: 10;
    top: 170px;
    bottom: 0px;
    width: 750px;
    left: 50%;
    margin-left: -375px;
    .product-box {
        .product-list {
            width: 750px;
        }
    }
}
</style>
